import React from 'react';
import { useNavigate, Link} from 'react-router-dom';
import { ArrowRight, ShoppingBag } from 'lucide-react';

const ShopPage = () => {
  const navigate = useNavigate();
  // 20 Categories and Subcategories with images
  const shopCategories = [
    // Main Categories
    {
      id: 1,
      name: 'Dressers',
      slug: 'dressers',
      image: '/images/products/Dressers/8dd/img1.jpeg',
      type: 'category',
      count: '45 Products',
      description: 'Elegant storage solutions'
    },
    {
      id: 2,
      name: 'Wooden Beds',
      slug: 'wooden-beds',
      image: '/images/products/Queen_bed/img5.jpeg',
      type: 'category',
      count: '32 Products',
      description: 'Premium quality bed frames'
    },
    {
      id: 3,
      name: 'Wardrobes',
      slug: 'wardrobes',
      image: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?w=600&h=400&fit=crop',
      type: 'category',
      count: '28 Products',
      description: 'Spacious clothing storage'
    },
    {
      id: 4,
      name: 'Bookshelves',
      slug: 'bookshelves',
      image: 'https://images.unsplash.com/photo-1594620302200-9a762244a156?w=600&h=400&fit=crop',
      type: 'category',
      count: '22 Products',
      description: 'Stylish display units'
    },
    {
      id: 5,
      name: 'Chest Dressers',
      slug: 'chest-dressers',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop',
      type: 'category',
      count: '18 Products',
      description: 'Tall storage solutions'
    },
    {
      id: 6,
      name: 'Sidetables',
      slug: 'sidetables',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=400&fit=crop',
      type: 'category',
      count: '25 Products',
      description: 'Perfect bedside companions'
    },
    {
      id: 7,
      name: 'Mattresses',
      slug: 'mattresses',
      image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop',
      type: 'category',
      count: '30 Products',
      description: 'Comfortable sleep solutions'
    },
    {
      id: 8,
      name: 'Headboards',
      slug: 'headboards',
      image: 'https://images.unsplash.com/photo-1540574163026-643ea20ade25?w=600&h=400&fit=crop',
      type: 'category',
      count: '15 Products',
      description: 'Elegant bedroom accents'
    },
    
    // Popular Subcategories
    {
      id: 9,
      name: '6 Drawer Dressers',
      slug: 'dressers',
      subcategory: '6-drawer-dressers',
      image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=600&h=400&fit=crop&auto=format&q=80',
      type: 'subcategory',
      count: '12 Products',
      description: 'Popular size for bedrooms'
    },
    {
      id: 10,
      name: 'King Size Beds',
      slug: 'wooden-beds',
      subcategory: 'king-size',
      image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=600&h=400&fit=crop&auto=format&q=80&sat=-20',
      type: 'subcategory',
      count: '10 Products',
      description: 'Spacious luxury beds'
    },
    {
      id: 11,
      name: '4 Door Wardrobes',
      slug: 'wardrobes',
      subcategory: '4-door-wardrobes',
      image: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?w=600&h=400&fit=crop&auto=format&q=80&sat=-10',
      type: 'subcategory',
      count: '8 Products',
      description: 'Ample storage space'
    },
    {
      id: 12,
      name: '5 Drawer Chest',
      slug: 'chest-dressers',
      subcategory: '5-drawer-chest',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=400&fit=crop&auto=format&q=80&sat=-5',
      type: 'subcategory',
      count: '7 Products',
      description: 'Vertical storage solution'
    },
    {
      id: 13,
      name: 'Queen Size Mattress',
      slug: 'mattresses',
      subcategory: 'queen-size',
      image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&h=400&fit=crop&auto=format&q=80&sat=-15',
      type: 'subcategory',
      count: '12 Products',
      description: 'Most popular size'
    },
    {
      id: 14,
      name: '3 Drawer Sidetables',
      slug: 'sidetables',
      subcategory: '3-drawer-sidetables',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=400&fit=crop&auto=format&q=80&sat=-10',
      type: 'subcategory',
      count: '9 Products',
      description: 'Compact nightstands'
    },
    {
      id: 15,
      name: 'Dresser Mirrors',
      slug: 'dresser-mirrors',
      image: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=600&h=400&fit=crop',
      type: 'category',
      count: '14 Products',
      description: 'Complete your dresser'
    },
    {
      id: 16,
      name: '8 Drawer Dressers',
      slug: 'dressers',
      subcategory: '8-drawer-dressers',
      image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=600&h=400&fit=crop&auto=format&q=80&brightness=1.1',
      type: 'subcategory',
      count: '11 Products',
      description: 'Extra storage capacity'
    },
    {
      id: 17,
      name: 'Double Size Beds',
      slug: 'wooden-beds',
      subcategory: 'double-size',
      image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=600&h=400&fit=crop&auto=format&q=80&hue=10',
      type: 'subcategory',
      count: '8 Products',
      description: 'Perfect for couples'
    },
    {
      id: 18,
      name: 'Oven Stands',
      slug: 'oven-stands',
      image: 'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=600&h=400&fit=crop',
      type: 'category',
      count: '10 Products',
      description: 'Kitchen storage solutions'
    },
    {
      id: 19,
      name: '6 Door Wardrobes',
      slug: 'wardrobes',
      subcategory: '6-door-wardrobes',
      image: 'https://images.unsplash.com/photo-1595515106969-1ce29566ff1c?w=600&h=400&fit=crop&auto=format&q=80&brightness=1.1',
      type: 'subcategory',
      count: '6 Products',
      description: 'Large family wardrobes'
    },
    {
      id: 20,
      name: '4 Drawer Dresser Mirror',
      slug: 'dresser-mirrors',
      subcategory: '4-drawer-dresser-mirror',
      image: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=600&h=400&fit=crop&auto=format&q=80&sat=-10',
      type: 'subcategory',
      count: '5 Products',
      description: 'Matching mirror sets'
    },
  ];

  const handleCategoryClick = (item) => {
  const params = new URLSearchParams({
    category: item.slug,
    ...(item.subcategory && { subcategory: item.subcategory })
  });
  navigate(`/products?${params.toString()}`);
};

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-primary-50/30">
      {/* Page Header */}
      <div className="bg-gradient-to-r from-primary-600 to-accent-600 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-4">
              <ShoppingBag className="w-5 h-5 text-white" />
              <span className="text-sm font-semibold text-white">
                Explore Our Collections
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-4">
              Shop by Category
            </h1>
            <p className="text-xl text-white/90">
              Browse our carefully curated selection of furniture for every room in your home
            </p>
          </div>
        </div>
      </div>

      {/* Categories Grid */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {shopCategories.map((item, index) => (
            <div
              key={item.id}
              className="group bg-white rounded-xl overflow-hidden shadow-soft card-hover cursor-pointer animate-slide-up"
              style={{ animationDelay: `${index * 0.05}s` }}
              onClick={() => handleCategoryClick(item)}
            >
              {/* Image Container */}
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
                
                {/* Type Badge */}
                <div className="absolute top-3 right-3">
                  <span className={`px-3 py-1 text-xs font-bold rounded-full ${
                    item.type === 'category'
                      ? 'bg-primary-600 text-white'
                      : 'bg-accent-600 text-white'
                  }`}>
                    {item.type === 'category' ? 'Category' : 'Collection'}
                  </span>
                </div>

                {/* Hover Arrow */}
                <div className="absolute bottom-3 right-3 w-10 h-10 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                  <ArrowRight className="w-5 h-5 text-primary-700" />
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-xl font-display font-bold text-dark-800 mb-2 group-hover:text-primary-700 transition-colors duration-300">
                  {item.name}
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  {item.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-primary-700">
                    {item.count}
                  </span>
                  <button className="text-sm font-medium text-primary-700 hover:text-primary-800 flex items-center gap-1 group-hover:gap-2 transition-all duration-300">
                    Browse
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-dark-900 mb-4">
              Can't Find What You're Looking For?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Our team is here to help you find the perfect furniture for your home
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" >
               <button className="px-8 py-4 bg-primary-600 text-white rounded-lg font-semibold hover:bg-primary-700 transition-all duration-300 transform hover:scale-105 shadow-soft">
                Contact Us
              </button>
              </Link>
              <Link to="/products" >
              <button className="px-8 py-4 bg-white border-2 border-primary-300 text-primary-700 rounded-lg font-semibold hover:bg-primary-50 transition-all duration-300">
                View All Products
              </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-gradient-to-br from-primary-50 to-accent-50 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-white rounded-full flex items-center justify-center shadow-soft">
                <svg className="w-8 h-8 text-primary-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="font-display font-bold text-lg text-dark-800 mb-2">Quality Assured</h3>
              <p className="text-sm text-gray-600">Premium materials & craftsmanship</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-white rounded-full flex items-center justify-center shadow-soft">
                <svg className="w-8 h-8 text-accent-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="font-display font-bold text-lg text-dark-800 mb-2">Best Prices</h3>
              <p className="text-sm text-gray-600">Luxury-affordable furniture</p>
            </div>

             <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-white rounded-full flex items-center justify-center shadow-soft">
                <svg className="w-8 h-8 text-primary-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                </svg>
              </div>
              <h3 className="font-display font-bold text-lg text-dark-800 mb-2">Fast Shipping</h3>
              <p className="text-sm text-gray-600">Within 2 working</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-white rounded-full flex items-center justify-center shadow-soft">
                <svg className="w-8 h-8 text-accent-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="font-display font-bold text-lg text-dark-800 mb-2">Expert Support</h3>
              <p className="text-sm text-gray-600">24/7 customer service</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopPage;
